import { createAction, props } from '@ngrx/store';

import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';
import { DireccionGeograficaIDE } from '../entity-direcciones-geografica-ide/direcciones-geografica-ide.model';

// LOAD REQUEST

export const entityDireccionGeograficaExactaIDELoadRequest = createAction(
  '[ENTITYDIRECCIONESGEOGRAFICASIDE] Direccion Exacta Load Request',
  props<{ d: DireccionGeograficaIDE, mapa: string }>()
);

export const entityDireccionGeograficaExactaIDELoadFailure = createAction(
  '[ENTITYDIRECCIONESGEOGRAFICASIDE] Direccion Exacta Load Failure',
  props<{ error: Error }>()
);

export const entityDireccionGeograficaExactaIDELoadSuccess = createAction(
  '[ENTITYDIRECCIONESGEOGRAFICASIDE] Direccion Exacta Load Success',
  props<{ items: DireccionGeograficaIDE[] }>()
);

